module.exports = __webpack_public_path__ + "static/media/GMP.6ee6c3e4.jpg";